export const GET_LIST_THUCHINGOAILE = "GET_LIST_THUCHINGOAILE";
export const GET_LIST_THUCHINGOAILE_SUCCESS = "GET_LIST_THUCHINGOAILE_SUCCESS";
export const GET_LIST_THUCHINGOAILE_FAILURE = "GET_LIST_THUCHINGOAILE_FAILURE";
